import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {TransactionService} from '../../../transaction/transaction.service';
import {DatePipe} from '@angular/common';
import {CommissionComponent} from '../commission.component';
import {CommissionService} from '../commission.service';

@Component({
  selector: 'app-add-commission',
  templateUrl: './add-commission.component.html',
  styleUrls: ['./add-commission.component.css']
})
export class AddCommissionComponent implements OnInit {

    addPhysicianCommissionForm: FormGroup;
    fromDate = new Date();
    toDate = new Date();
    commissionType= ["PERCENTAGE","FIXED_AMOUNT"];
    currency= ["$", "₹", "C$"];
    physicianName:string=''

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<CommissionComponent>,
              private _formBuilder: FormBuilder,
              private commissionService:CommissionService,
              private datepipe: DatePipe) {
    console.log(this.data);
  this.physicianName = this.data.name;
      this.addPhysicianCommissionForm = this. _formBuilder.group({
          physicianId: [this.data.id.value,Validators.required],
          commissionType: ['PERCENTAGE',Validators.required],
          commissionValue: ['',Validators.required],
          currency: ['₹',Validators.required],
          fromDate: [this.fromDate , Validators.required],
          toDate: [this.toDate, Validators.required]
      });
  }

  ngOnInit() {
  }

  addPhysicianCommission(){

    const payload = {
        "physicianId": this.addPhysicianCommissionForm.get('physicianId').value,
        "commissionType": this.addPhysicianCommissionForm.get('commissionType').value,
        "commissionValue": this.addPhysicianCommissionForm.get('commissionValue').value,
        "currency": this.addPhysicianCommissionForm.get('currency').value,
      "fromDate": this.datepipe.transform(this.addPhysicianCommissionForm.get('fromDate').value, 'yyyy-MM-ddT00:00:00ZZZZZ'),
        "toDate": this.datepipe.transform(this.addPhysicianCommissionForm.get('toDate').value, 'yyyy-MM-ddT23:59:59ZZZZZ')
    };

    this.commissionService.saveCommission(payload).subscribe(res=>{
        this.dialogRef.close();
    }, (error) => {
     console.log(error);
        // this.toastr.error('', 'Please try again');
    });
  }

}
